import BaseStrategy from './BaseStrategy';

const IDC = () => <BaseStrategy authStep="idc" />;

export default IDC;
